<div class="px-2 lg:px-8 border-t-2 border-t-primary-700 border-white py-10 text-sm">
  <div class="flex flex-col items-center md:flex-row gap-10 justify-center md:justify-between">
    <div>
      <div class="flex flex-row items-center">
        <div class="flex flex-col">
          <img class="h-24 w-auto mr-8" src="/assets/images/logo.png" alt="" />
        </div>

        @if (identity | async; as i) {
          <div class="flex flex-col space-y-1">
            <p class="m-0">{{ i.fullName }}</p>
            <p class="m-0">{{ i.street }}</p>
            <p class="m-0">{{ i.postalCode }} {{ i.locality }}</p>
            <a class="flex flex-row items-center" target="_blank" [href]="phoneLink | async">
              <ng-icon name="heroPhoneSolid" size="12px" class="mr-2"></ng-icon>
              <span>{{ i.mainPhone }}</span>
            </a>
            <a class="flex flex-row items-center" target="_blank" [href]="mailToLink | async">
              <ng-icon name="heroEnvelopeSolid" size="12px" class="mr-2"></ng-icon>
              <span>{{ i.mainEMail }}</span>
            </a>
          </div>
        }
      </div>
    </div>
    <!-- <div>
      <table class="table-auto w-full">
        <tbody>
          <tr>
            <td class="pr-6 py-2">Dienstag & Mittwoch</td>
            <td class="pl-6 py-2 float-right">09:00 - 12:00 Uhr<br />13:30 - 18:00 Uhr</td>
          </tr>
          <tr>
            <td class="pr-6 py-2">Donnerstag</td>
            <td class="pl-6 py-2 float-right">09:00 - 12:00 Uhr<br />13:30 - 20:00 Uhr</td>
          </tr>
          <tr>
            <td class="pr-6 py-2">Freitag</td>
            <td class="pl-6 py-2 float-right">09:00 - 12:00 Uhr<br />13:30 - 18:00 Uhr</td>
          </tr>
          <tr>
            <td class="pr-6 py-2">Samstag</td>
            <td class="pl-6 py-2 float-right">09:00 - 15:00 Uhr</td>
          </tr>
        </tbody>
      </table>
      <div class="mt-4 sm:flex sm:items-center sm:justify-between w-full">
        <div class="flex flex-col items-center sm:items-end text-black w-full">
          <select
            id="vatCalculation"
            name="vatCalculation"
            class="w-full block rounded-md border-gray-300 py-2 pl-3 pr-10 text-sm focus:border-primary-600 focus:outline-none focus:ring-primary-700"
            [ngModel]="webShop.observeVatCalculationMethod() | async"
            (ngModelChange)="changeVatCalc($event)"
          >
            @for (o of vatCalc; track o) {
              <option [value]="o._id">
                {{ o.text | i18n }}
              </option>
            }
          </select>
        </div>
      </div>
    </div> -->
  </div>
</div>
<div class="bg-primary-700 text-white text-xs flex flex-col items-center md:flex-row md:justify-between py-2 px-2 lg:px-8">
  <div class="flex flex-row space-x-4">
    <a routerLink="/imprint">{{ { key: 'imprint' } | i18n }}</a>
    <a routerLink="/privacy">{{ { key: 'privacy' } | i18n }}</a>
    <a routerLink="/legal">{{ { key: 'legal' } | i18n }}</a>
  </div>
  <div class="mt-2 md:mt-0">&copy; {{ currentYear }} Hundesport St. Gallen</div>
</div>
